import type { UserChangeRequestReason } from '@contracts/changeRequest/ChangeRequestContract';
import { ChangeRequestClient } from '@src/changeRequest/ChangeRequestClient';
import type { DirtyFields } from '@src/changeRequest/DirtyFields';
import { flattenDirtyFields } from '@src/changeRequest/DirtyFields';
import { sanitizeEditOrderInputs } from '@src/orders/schemas/SanitizeEditOrderInputs';
import { useMutation } from '@tanstack/react-query';

export const useCreateChangeRequest = ({
  orderId,
  reason,
  onSuccess,
  onError,
}: {
  orderId: string;
  reason: UserChangeRequestReason;
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { mutate } = useMutation<
    void,
    Error,
    {
      formValues: Record<string, unknown>;
      dirtyFields: DirtyFields;
    }
  >({
    mutationFn: async ({ formValues, dirtyFields }): Promise<void> => {
      const sanitizedFormValues = sanitizeEditOrderInputs(formValues);
      await ChangeRequestClient.createChangeRequest({
        orderId,
        reason,
        form: sanitizedFormValues,
        dirtyFields: flattenDirtyFields(dirtyFields),
      });
    },
    onSuccess,
    onError,
  });

  return { createChangeRequest: mutate };
};
